const playlistsData = [{
    1: {
        playlistTitle: "October 15th 2019 Arteezy Stream",
        playlistLink: "12ipUXa6wIEKC5ROnwDwWI?si=OVu7wqgGRjqpCphblHUR_w"
    },
    2: {
        playlistTitle: "November 2nd 2019 Arteezy Stream Part 1",
        playlistLink: "4iP0tJ8Pkk0RyCHeYEQn1f?si=pXAeXPcEQf25aAzrDocLWw"
    },
    3: {
        playlistTitle: "November 2nd 2019 Arteezy Stream Part 2",
        playlistLink: "1QIXWVBTHi9azshXrUtd2A?si=3NPyqqVAT-qD7ZsCDeBvag"
    },
    4: {
        playlistTitle: "November 3rd 2019 Arteezy Stream Part 1",
        playlistLink: "3KsgKpM3vH2uCKhl6Mn9iQ?si=Zv6RnvcATcaTmVYS8Z45iQ"
    },
    5: {
        playlistTitle: "March 4th 2020 Arteezy Stream",
        playlistLink: "2WCjXh0xHNKGi7NePwN4RD?si=hHdjokYkQcqf5GbPtkP2IA"
    }
}]

export default playlistsData;